import axios from "axios/index"
import {isNull} from "lodash/lang"
import {GET_ID_PROCESSING} from "../../store/modules/processing"
import store from "../../store"
import {UPLOADER_URL, PROJECT_URL} from "../../globals"
import MD5 from 'js-md5';
import {listUploadedImages} from "../../api/api-project"
import {apiAuth} from "../../main"

export default class UploadFileHolder {
  constructor(fileObject, onUploadProgress, onUploadEnded, onUploadError, instance = null) {
    this.name = fileObject.name
    this.size = fileObject.size

    this.uploadProgress = 0
    this.uploadStarted = false
    this.uploadCompleted = false

    this.fileObject = fileObject

    if (instance) {
      this.onUploadProgress = onUploadProgress.bind(instance)
      this.onUploadEnded = onUploadEnded.bind(instance)
      this.onUploadError = onUploadError.bind(instance)
    } else {
      this.onUploadProgress = onUploadProgress
      this.onUploadEnded = onUploadEnded
      this.onUploadError = onUploadError
    }

    this.source = null
  }

  progress() {
    setTimeout(function () {
      this.uploadProgress += 1
      this.progress()
    }.bind(this), 1000)
  }

  getUploadProgress() {
    return this.uploadProgress
  }
  async startUpload(uploadUrl, authorization = null, imgQuantity = 0, fileName = null, processingId = null) {
    this.source = axios.CancelToken.source()
    const request = axios.create({
      onUploadProgress:
        progressEvent => {
          this.uploadProgress = (progressEvent.loaded / this.size) * 100
          if (this.onUploadProgress) this.onUploadProgress(this.uploadProgress, this)
        },
    })

    const headers = {
      "Content-Type": this.fileObject.type,
      "Content-Name": (isNull(fileName)) ? this.name : fileName,
      // "Content-Length": this.fileObject.size,
    }

    if (authorization) {
      headers.Authorization = authorization
    }
    fileName = this.fileObject.name ? this.fileObject.name : '';

    if(this.fileObject.type=="application/zip" || fileName.includes('.zip')){
        let cd_processing = store.getters[GET_ID_PROCESSING]
        if(processingId){
            cd_processing = processingId
        }
        //Realizar post dos arquios zip em multipart com lib evaporate/resumable
        this.uploadStarted = true
        request.get(UPLOADER_URL+"/upload/pressigned_url_upload_file/"+cd_processing+"/"+this.name, {
            headers: headers,
            cancelToken: this.source.token,
            withCredentials: true,
          }).then((response) => {
            const url = response.data.data.url
            const key = response.data.data.fields.key
//            const policy = response.data.data.fields.policy
//            const signature = response.data.data.fields.signature
            const aws_key = response.data.data.fields.AWSAccessKeyId
//            var data = new FormData();
//            data.append('AWSAccessKeyId', aws_key);
//            data.append('key', key);
//            data.append('policy', policy);
//            data.append('signature', signature);
//            data.append("file", this.fileObject, this.fileObject.name);
//Axios: Funciona e Faz upload de um Arquivo direto Para AWS
//            request.post(url, data, {
//                headers: {},
//            }).then(() => {
//                this.uploadStarted = false
//                this.uploadCompleted = true
//                if (this.onUploadEnded) this.onUploadEnded(this)
//              })
//              .catch((err) => {
//                if (this.onUploadError) this.onUploadError(err, this)
//              })

//Upload Pela Lib Evaporate
            const Evaporate = require('evaporate');
            const Crypto = require('crypto');
            const md5 = (x) => { const o = MD5.create(); o.update(x); return o.base64(); };
            const config = {
              signerUrl: UPLOADER_URL+"/upload/get_aws_signature_to_evaporate/",
              aws_key: aws_key,
              aws_url: url.substr(0,url.length-1),
              awsRegion: "us-east-1",
              bucket: "horus-platform",
              cloudfront: true,
              logging: false,
              sendCanonicalRequestToSignerUrl: false,
              computeContentMd5: true,
              cryptoMd5Method: (_) => md5(_),
              cryptoHexEncodedHash256: function (data) { return Crypto.createHash('sha256').update(data).digest('hex')},
              signHeaders: {
                "Authorization": function() {
                  var authToken = apiAuth.getAuthToken(false)
                  var dtLastTokenRenew = localStorage.getItem('dtLastTokenRenew')

                  if (dtLastTokenRenew == null) {
                    console.log("Token last renew not found")
                    apiAuth.oauthRefreshToken().then(() => {
                      var dtTokenRenewNow = new Date()
                      localStorage.setItem('dtLastTokenRenew', dtTokenRenewNow)
                      authToken = apiAuth.getAuthToken(false)
                      console.log("New token generated")
                      return `Bearer ${authToken}`
                    })
                  }

                  dtLastTokenRenew = new Date(dtLastTokenRenew).getTime()
                  var dtNow = Date.now()

                  var diffMs = (dtNow - dtLastTokenRenew);
                  var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000)
                  if (diffMins > 20) {
                    apiAuth.oauthRefreshToken().then(() => {
                      apiAuth.oauthRefreshToken()
                      var dtTokenRenewNow = new Date()
                      localStorage.setItem('dtLastTokenRenew', dtTokenRenewNow)
                      authToken = apiAuth.getAuthToken(false)
                      console.log("New token generated")
                      return `Bearer ${authToken}`
                    })
                  } else {
                    return `Bearer ${authToken}`
                  }
                }
              }
            }
            const uploadFile = evaporate => {
              const addConfig = {
                name: key,
                file: this.fileObject,
                progress: (progressValue) => {
                                            this.uploadProgress = progressValue * 100
                                            if (this.onUploadProgress) this.onUploadProgress(this.uploadProgress, this)
                                        },
                complete: () => {
                                            listUploadedImages(authorization.substr(7,authorization.length), cd_processing).then((res) => {
                                                 const arquivos = res.data.data.files
                                                 arquivos.forEach((item)=>{
                                                    if(this.name==item.name){
                                                        this.uploadStarted = false;
                                                        this.uploadCompleted = true;
                                                        if (this.onUploadEnded) this.onUploadEnded(this);
                                                    }
                                                 });
                                            })
                                        },
              }

              const overrides = {
               // bucket: "horus-platform"
               name: key
              };
              evaporate.add(addConfig, overrides)
            }
            Evaporate.create(config).then(uploadFile);
      }).catch((err) => {
         if (this.onUploadError) this.onUploadError(err, this)
      })
      if (this.fileObject.isZip){
        const zipSize = this.fileObject.size
        const width = parseInt(Math.sqrt(zipSize/imgQuantity))
        const height = width

        const imgGigaPixels = (width * height) / 10e8
        const newGigaPixels = imgQuantity * imgGigaPixels

        console.log(newGigaPixels)
        let data= {
            total_giga_pixels: newGigaPixels,
            total_images: imgQuantity
          }
        let headers2 = {}
        headers2.Authorization = authorization
        request.post(PROJECT_URL+"/processings/"+cd_processing+"/save-processing-data/",data, {
            headers: headers2,
            withCredentials: true,
        })     
      }
    }else{
        request.put(uploadUrl, this.fileObject, {
            headers: headers,
            cancelToken: this.source.token,
            withCredentials: true,
          })
          .then(() => {
            this.uploadStarted = false
            this.uploadCompleted = true
            if (this.onUploadEnded) this.onUploadEnded(this)
          })
          .catch((err) => {
            if (this.onUploadError) this.onUploadError(err, this)
          })
        this.uploadStarted = true
    }
  }

  cancelUpload() {
    if (!this.uploadStarted) return
    this.source.cancel("Operation canceled")
  }
}

export const isUploadFileHolder = inst => {
  return inst.hasOwnProperty("fileObject")
}
